import React from 'react';
import  { capitalizeFirstLetter }  from '../../_global/js/Utils.js';
import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import PropTypes from 'prop-types';
import { InfoCircle } from '../../SVGs/svg.imports.js';

const TileOptions = (props) => {
   
    const { matrixData, setOptionSelectionId, checked, setChecked, setShowOptionTooltipModal, setTooltipContent } = useStore(state =>({
        matrixData: state.matrixData,  
        setOptionSelectionId: state.setOptionSelectionId,
        checked: state.checked,
        setChecked: state.setChecked,
        setShowOptionTooltipModal: state.setShowOptionTooltipModal,
        setTooltipContent: state.setTooltipContent,
      }), shallow);


    const clickOption = (e) => {
        setChecked(e.target.id);
        setOptionSelectionId(e.target.id)
    }

    const focusOption = (e) => {
      const id = e.target.id;
      let optionWrapper = document.getElementById(id).closest('.step_option');
      optionWrapper.classList.add('option-focus');
    }

    const removeFocus = (e) => {
      const id = e.target.id;
      let optionWrapper = document.getElementById(id).closest('.step_option');
      optionWrapper.classList.remove('option-focus'); 
    }

    const openOptionTooltip = (e) => {
      setShowOptionTooltipModal(true);
      const id = e.currentTarget.dataset.id;
      const optionTooltip = matrixData['pages'][id]['option_displayed_on_parent_tooltip'];
      setTooltipContent(optionTooltip);
    }


   let children = matrixData['pages'][props.pageId]['children'];

    const optionsListing = children.map((item) => {
        // const rawTileHtml = matrixData['pages'][item]['option_displayed_on_parent'];
        const optionTooltip = matrixData['pages'][item]['option_displayed_on_parent_tooltip'];
        
        return (
        <div 
            className={`step_option decision_box--option step_option--tile step_option--4 ${checked === item ? "highlight": ""}`}
            key={item}
        >
            <label htmlFor={item} className="step_option-inner">
                <input type="radio" id={item} name="decision_step635" onClick={clickOption} onFocus={focusOption} onBlur={removeFocus} />
                <div className="option_span">
                        {capitalizeFirstLetter(matrixData['pages'][item]['option_displayed_on_parent'])}
                        {optionTooltip ? <button role="button" onClick={openOptionTooltip}  className="option_tooltip" data-id={item}><InfoCircle /></button> : ''}
                    </div>
            </label>
        </div>

        )
    })

    

  return (
    <div className="step_options step_options--tile">
        {optionsListing}
    </div> 
  )
}

TileOptions.propTypes = {
  pageId: PropTypes.string
}

export default TileOptions;